export const COMMENT = 'comment';
export const CLIENT_COMMENT = 'clientComment';
export const SUR_COMMENT = 'surComment';

export const parseText = (text, createLink) => {
  const DOMAIN_EXTENSIONS = ['com', 'net', 'org', 'io', 'co', 'kr', 'jp', 'cn', 'edu', 'gov', 'mil', 'biz', 'info', 'me', 'tv'].join('|');
  const URL_PATTERN = new RegExp(`(https?:\\/\\/[^\\s]+|www\\.[^\\s]+|[a-zA-Z0-9-]+\\.(${DOMAIN_EXTENSIONS}))\\b`, 'gi');
  const elements = [];
  let lastIndex = 0;
  let match;

  while ((match = URL_PATTERN.exec(text)) !== null) {
    // 링크 이전의 일반 텍스트 추가
    if (match.index > lastIndex) {
      elements.push(text.substring(lastIndex, match.index));
    }

    // 링크 추가
    elements.push(createLink(match[0], match.index));
    lastIndex = match.index + match[0].length;
  }

  // 마지막 링크 이후의 텍스트 추가
  if (lastIndex < text.length) {
    elements.push(text.substring(lastIndex));
  }

  return elements;
};
